import { IncidentDto, IncidentPhotoDto, TypeIncidentDto, VisiteDto } from "src/api/models";

export interface VisitesState {
  visite: VisiteDto;
  typesIncidents: TypeIncidentDto[];
  incident: IncidentDto;
  photosIncident: IncidentPhotoDto[];
  error: string;
}

export const VisitesStateDefault = {
  visite: null,
  typesIncidents: null,
  incident: null,
  photosIncident: null,
  error: null
}

